import {
    ORDERS_LOADING,
    FETCH_ORDERS_SUCCESS,
    FETCH_ORDER_HEADER_SUCCESS,
    FETCH_PLANOGRAM_DATA_SUCCESS,
    SUBMIT_ORDER_SUCCESS,
    ADD_OR_UPDATE_ORDER_SUCCESS,
    UN_SUBMIT_ORDER_SUCCESS,
    FETCH_ORDER_DETAIL_SUCCESS,
    ADD_OR_UPDATE_ORDER,
    SUBMIT_ORDER,
    UN_SUBMIT_ORDER,
} from "actions/types";

const initialState = {
    orders: [],
    orderOptions: {},
    orderHeader: {},
    planograms: [],
    orderDetails: [],
    orderDetailAddOrUpdate: {},
    orderDetailAddOrUpdateError: "",
    isSubmitted: false,
    orderSubmitError: "",
    loading: false
};

export default function (state = initialState, action) {
    switch (action.type) {
        case ORDERS_LOADING:
            return {
                ...state,
                loading: action.payload,
            };
        case FETCH_ORDERS_SUCCESS:
            return {
                ...state,
                orders: action.payload.payload,
                orderOptions: {
                    pageNumber: action.payload.pageNumber,
                    pageSize: action.payload.pageSize,
                    totalFilteredRecords: action.payload.totalFilteredRecords,
                    totalRecords: action.payload.totalRecords,
                },
                loading: false,
                orderSubmitError: "",
                orderDetailAddOrUpdateError: "",
            };
        case FETCH_ORDER_HEADER_SUCCESS:
            return {
                ...state,
                orderHeader: action.payload,
                orderSubmitError: "",
                orderDetailAddOrUpdateError: "",
            };
        case FETCH_PLANOGRAM_DATA_SUCCESS:
            return {
                ...state,
                planograms: action.payload,
                loading: false
            };
        case FETCH_ORDER_DETAIL_SUCCESS:
            return {
                ...state,
                orderDetails: action.payload,
                orderSubmitError: "",
                orderDetailAddOrUpdateError: "",
                loading: false
            };
        case SUBMIT_ORDER_SUCCESS:
            return {
                ...state,
                isSubmitted: true,
                orderSubmitError: "",
                orderDetailAddOrUpdateError: "",
                loading: false
            };
        case UN_SUBMIT_ORDER_SUCCESS:
            return {
                ...state,
                isSubmitted: false,
                orderSubmitError: "",
                orderDetailAddOrUpdateError: "",
                loading: false
            };
        case ADD_OR_UPDATE_ORDER_SUCCESS: {
            return {
                ...state,
                orderDetailAddOrUpdate: action.payload,
                orderDetailAddOrUpdateError: "",
                orderSubmitError: "",
                loading: action.payload
            };
        }
        case ADD_OR_UPDATE_ORDER: {
            return {
                ...state,
                loading: false,
                orderDetailAddOrUpdateError: action.payload[0]
            };
        }
        case SUBMIT_ORDER: {
            return {
                ...state,
                loading: false,
                orderSubmitError: action.payload[0]
            };
        }
        case UN_SUBMIT_ORDER: {
            return {
                ...state,
                loading: false,
                orderSubmitError: action.payload[0]
            };
        }

        default:
            return state;
    }
}
